import { Color, LoaderSize } from "@enxcs/dap-ui-stratos";
import { FC, useRef } from "react";
import { SpinnerContainer } from "./LoadingSpinner.styled";

interface LoadingSpinnerProps {
  size?: LoaderSize;
  animationDelay?: string;
}

const SPINNER_TIMESTAMP = Date.now();

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = LoaderSize.V12 }) => {
  const ref = useRef<HTMLSpanElement>(null);
  const animation = ref.current?.getAnimations()[0];

  if (animation) {
    animation.startTime = SPINNER_TIMESTAMP;
    animation.play();
  }

  return (
    <SpinnerContainer ref={ref} data-testid="loading-spinner" role="progressbar" aria-hidden="true">
      <svg width={size} height={size} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d={
            "M28 9.33342V4.66675C24.9358 4.66675 21.9016 5.27028 19.0707 6.44289C16.2397 7.6155 13.6675 9.33422 11.5008 11.5009C7.12495 15.8768 4.66663 21.8117 4.66663 28.0001H9.33329C9.33329 23.0494 11.3 18.3014 14.8006 14.8008C18.3013 11.3001 23.0493 9.33342 28 9.33342Z"
          }
          fill={Color.Blue.V40}
        />
      </svg>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
